<app-background-animation></app-background-animation>
<div class="accept-invite-container">
    <div class="invite-card">
        <mat-card style="width:95vw">
            <mat-card-header>
                <div class="rotating-logo"></div>
            </mat-card-header>
            <mat-card-content>
                <div *ngIf="isLoading">
                    <mat-spinner></mat-spinner>
                    <h2>Loading Prescription Details...</h2>
                </div>
                <div *ngIf="!isLoading && !errorMessage && !pdfUrl">
                    <h2>Prescription Verification</h2>
                    <p>Please wait while we verify the prescription details.</p>
                </div>
                <div *ngIf="errorMessage">
                    <h2>Prescription Verification Failed</h2>
                    <p>{{ errorMessage }}</p>
                </div>
                <!-- <a *ngIf="downloadLink" [href]="downloadLink" download>
                    <button mat-raised-button color="primary">
                        Download Original Prescription
                    </button>
                </a> -->

                <ng-container *ngIf="pdfUrl">
                    <div class="prescription-note">
                        <span>
                            <strong>Attention: </strong>This preview shows the prescription <strong>exactly</strong> as
                            it was originally created. If you notice any differences between what you see here and what
                            was submitted at the pharmacy, please <strong>contact the prescribing doctor
                                immediately</strong>.
                        </span>
                    </div>
                    <ngx-extended-pdf-viewer [src]="rawPdfUrl" [useBrowserLocale]="true" width="100%"
                        [showDownloadButton]="false" [showPrintButton]="false" [showPresentationModeButton]="false"
                        [showOpenFileButton]="false" [showPagingButtons]="false" [showFindButton]="false"
                        [showZoomButtons]="true"></ngx-extended-pdf-viewer>
                </ng-container>

            </mat-card-content>
        </mat-card>
    </div>
</div>